import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';

const getArrayFromStringOfNumbers = (string: string): number[] => string.split(',').map((item) => parseInt(item, 10));
export const getAccommodationFacilitiesFromQuery = (query: SearchParams) =>
  [
    ...new Set([
      // ...(query.accomodation_facilities ? getArrayFromStringOfNumbers(query.accomodation_facilities) : []),
      ...(query.general_accomodation_facilities
        ? getArrayFromStringOfNumbers(query.general_accomodation_facilities)
        : []),
      ...(query.family_accomodation_facilities
        ? getArrayFromStringOfNumbers(query.family_accomodation_facilities)
        : []),
      ...(query.activity_accomodation_facilities
        ? getArrayFromStringOfNumbers(query.activity_accomodation_facilities)
        : []),
      ...(query.wellness_accomodation_facilities
        ? getArrayFromStringOfNumbers(query.wellness_accomodation_facilities)
        : []),
      ...(query.food_accomodation_facilities ? getArrayFromStringOfNumbers(query.food_accomodation_facilities) : []),
    ]),
  ].join(',');

export const createSearchParamsAccommodationFacilities = (searchParams: SearchParams): SearchParams => {
  const searchParamsClone = { ...searchParams };

  searchParamsClone[URLParameters.ACCOMODATION_FACILITIES] = getAccommodationFacilitiesFromQuery(searchParamsClone);
  if (!searchParamsClone[URLParameters.ACCOMODATION_FACILITIES])
    delete searchParamsClone[URLParameters.ACCOMODATION_FACILITIES];

  return searchParamsClone;
};
